import { createRequestTypes } from '../utils';

export const FETCH_RAWMAT_PHRASES = createRequestTypes('rawMatPhrase/FETCH_RAWMAT_PHRASES');
export const FETCH_ALL_RAWMAT_PHRASES = createRequestTypes('rawMatPhrase/FETCH_ALL_RAWMAT_PHRASES');
export const DELETE_RAWMAT_PHRASE = createRequestTypes('rawMatPhrase/DELETE_RAWMAT_PHRASE');
export const SAVE_RAWMAT_PHRASE = createRequestTypes('rawMatPhrase/SAVE_RAWMAT_PHRASE');
